import React, { FC } from 'react';
import { useTheme } from '@mui/material';

import { SuitcaseIcon } from 'src/shared/components';
import { useTranslate } from 'src/shared/providers';

interface Props {
  schedule?: string;
  isUnpublished?: boolean;
  absence?: string;
}

export const CalenderMySchedule: FC<Props> = ({ schedule, isUnpublished, absence }) => {
  const theme = useTheme();
  const { t } = useTranslate();

  const scheduleContent = () => {
    if (absence) {
      return (
        <div style={{ marginLeft: '-1px' }} className={`monthly-event first info ${theme.palette.mode} bg-transparent`}>
          <span className="w-100 event-title">{absence}</span>
        </div>
      );
    }
    if (isUnpublished) {
      return <span>{t('calendar.notPublished')}</span>;
    }
    return schedule ? (
      <div style={{ marginLeft: '-1px' }} className={`monthly-event first info ${theme.palette.mode} bg-transparent`}>
        <span className="w-100 event-title">{schedule}</span>
      </div>
    ) : (
      <span>-</span>
    );
  };

  return (
    <div style={{ marginLeft: '-24px' }}>
      <div className="d-flex align-items-center mb-3">
        <SuitcaseIcon color="#6C757D" size={16} className="me-2" />
        <span className="fw-500 me-1">{t('calendar.mySchedule')}</span>
      </div>
      {scheduleContent()}
    </div>
  );
};
